import { render, staticRenderFns } from "./SliderEdit.vue?vue&type=template&id=a1b6c91e&"
import script from "./SliderEdit.vue?vue&type=script&lang=js&"
export * from "./SliderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports